export const iconFontAwesomeArrowsCircleChevronRight = (
	<i className="fa-solid fa-circle-chevron-right"></i>
);
